videojs.addLanguage('ru', {
  "Audiotracks": "Аудиодорожка",
  "Commentator": "Комментатор",
  "Accept audiotracks settings": "Принять"
});
